/* eslint-disable @typescript-eslint/no-unused-vars */
import * as Types from '../../../../graphql/generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type IInternalRegulationsQueryVariables = Types.Exact<{
  input?: Types.InputMaybe<Types.IInternalRegulationsInput>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;

export type IInternalRegulationsQuery = {
  __typename?: 'Query';
  internalRegulations: {
    __typename: 'InternalRegulationsConnection';
    edges: Array<{
      __typename: 'InternalRegulationEdge';
      cursor: string;
      node: {
        __typename: 'InternalRegulation';
        id?: string | null;
        title: string;
        status: Types.IInternalRegulationReviewStatus;
      };
    }>;
    pageInfo: { __typename: 'CursorPageInfo'; hasNextPage: boolean; endCursor?: string | null };
  };
};

export const InternalRegulationsDocument = gql`
  query InternalRegulations($input: InternalRegulationsInput, $first: Int, $after: String) {
    internalRegulations(input: $input, first: $first, after: $after) {
      __typename
      edges {
        __typename
        node {
          __typename
          id
          title
          status
        }
        cursor
      }
      pageInfo {
        __typename
        hasNextPage
        endCursor
      }
    }
  }
`;

/**
 * __useInternalRegulationsQuery__
 *
 * To run a query within a React component, call `useInternalRegulationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInternalRegulationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInternalRegulationsQuery({
 *   variables: {
 *      input: // value for 'input'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useInternalRegulationsQuery(
  baseOptions?: Apollo.QueryHookOptions<IInternalRegulationsQuery, IInternalRegulationsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<IInternalRegulationsQuery, IInternalRegulationsQueryVariables>(
    InternalRegulationsDocument,
    options,
  );
}
export function useInternalRegulationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<IInternalRegulationsQuery, IInternalRegulationsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<IInternalRegulationsQuery, IInternalRegulationsQueryVariables>(
    InternalRegulationsDocument,
    options,
  );
}
// @ts-ignore
export function useInternalRegulationsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<IInternalRegulationsQuery, IInternalRegulationsQueryVariables>,
): Apollo.UseSuspenseQueryResult<IInternalRegulationsQuery, IInternalRegulationsQueryVariables>;
export function useInternalRegulationsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<IInternalRegulationsQuery, IInternalRegulationsQueryVariables>,
): Apollo.UseSuspenseQueryResult<IInternalRegulationsQuery | undefined, IInternalRegulationsQueryVariables>;
export function useInternalRegulationsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<IInternalRegulationsQuery, IInternalRegulationsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<IInternalRegulationsQuery, IInternalRegulationsQueryVariables>(
    InternalRegulationsDocument,
    options,
  );
}
export type InternalRegulationsQueryHookResult = ReturnType<typeof useInternalRegulationsQuery>;
export type InternalRegulationsLazyQueryHookResult = ReturnType<typeof useInternalRegulationsLazyQuery>;
export type InternalRegulationsSuspenseQueryHookResult = ReturnType<typeof useInternalRegulationsSuspenseQuery>;
export type InternalRegulationsQueryResult = Apollo.QueryResult<
  IInternalRegulationsQuery,
  IInternalRegulationsQueryVariables
>;
